import { lazy } from 'react';
// Import Types
import type { PublicRoute } from './types';
// Import Constants
import { l, RouteLeaveConfirmationType } from 'constants/common';
import { RoutesList } from './constants';

const {
    CRM_SIGN_IN,
    SSO_SIGN_IN,
    CRM_RESET_PASSWORD,
    CRM_RESET_PASSWORD_CONFIRM,
    HOMEPAGE,
    DASHBOARD,
    SEGMENT_LIST,
    TEMPLATE_LIST,
    CAMPAIGN_LIST,
    SEGMENT_DYNAMIC_CREATE,
    SEGMENT_PREDEFINED_CREATE,
    SEGMENT_DYNAMIC_EDIT,
    SEGMENT_PREDEFINED_EDIT,
    SEGMENT_DYNAMIC_CLONE,
    SEGMENT_PREDEFINED_CLONE,
    SEGMENT_STATIC_CREATE,
    SEGMENT_COMPOSITE_CREATE,
    SEGMENT_NON_CUSTOMER_CREATE,
    SEGMENT_COMPOSITE_CLONE,
    SEGMENT_COMPOSITE_EDIT,
    TEMPLATE_CREATE_EMAIL,
    TEMPLATE_CREATE_PREDEFINED_EMAIL,
    TEMPLATE_CREATE_CLONE,
    TEMPLATE_CREATE_EDIT,
    TEMPLATE_CREATE_SMS,
    TEMPLATE_CREATE_PREDEFINED_SMS,
    TEMPLATE_CLONE_SMS,
    TEMPLATE_EDIT_SMS,
    TEMPLATE_EDIT_PREDEFINED_SMS,
    TEMPLATE_CLONE_PREDEFINED_SMS,
    TEMPLATE_EDIT_PREDEFINED_EMAIL,
    TEMPLATE_CLONE_PREDEFINED_EMAIL,
    TEMPLATE_EDIT_PREDEFINED_DYNAMIC_POP_UP,
    TEMPLATE_CLONE_PREDEFINED_DYNAMIC_POP_UP,
    TEMPLATE_EDIT_SOCIAL_PREDEFINED_VIBER,
    TEMPLATE_CLONE_SOCIAL_PREDEFINED_VIBER,
    TEMPLATE_CREATE_SOCIAL_WHATS_APP_PROVIDER,
    TEMPLATE_EDIT_SOCIAL_WHATS_APP_PROVIDER,
    TEMPLATE_CLONE_SOCIAL_WHATS_APP_PROVIDER,
    TEMPLATE_CREATE_PREDEFINED_SOCIAL_WHATS_APP_PROVIDER,
    TEMPLATE_EDIT_PREDEFINED_SOCIAL_WHATS_APP_PROVIDER,
    TEMPLATE_CLONE_PREDEFINED_SOCIAL_WHATS_APP_PROVIDER,
    TEMPLATE_CREATE_HOORY,
    TEMPLATE_CLONE_HOORY,
    TEMPLATE_EDIT_HOORY,
    TEMPLATE_CREATE_PREDEFINED_HOORY,
    TEMPLATE_CLONE_PREDEFINED_HOORY,
    TEMPLATE_EDIT_PREDEFINED_HOORY,
    TEMPLATE_CREATE_INTERNAL_MESSAGE,
    TEMPLATE_CREATE_PREDEFINED_INTERNAL_MESSAGE,
    TEMPLATE_CLONE_INTERNAL_MESSAGE,
    TEMPLATE_EDIT_INTERNAL_MESSAGE,
    TEMPLATE_EDIT_PREDEFINED_INTERNAL_MESSAGE,
    TEMPLATE_CLONE_PREDEFINED_INTERNAL_MESSAGE,
    TEMPLATE_EDIT_SOCIAL_PREDEFINED_TELEGRAM,
    TEMPLATE_CLONE_SOCIAL_PREDEFINED_TELEGRAM,
    TEMPLATE_CREATE_SOCIAL_TELEGRAM,
    TEMPLATE_CREATE_SOCIAL_WHATS_APP,
    TEMPLATE_CREATE_PREDEFINED_SOCIAL_TELEGRAM,
    TEMPLATE_CLONE_SOCIAL_TELEGRAM,
    TEMPLATE_EDIT_SOCIAL_TELEGRAM,
    TEMPLATE_EDIT_SOCIAL_WHATS_APP,
    TEMPLATE_CREATE_SOCIAL_VIBER,
    TEMPLATE_CREATE_PREDEFINED_SOCIAL_VIBER,
    TEMPLATE_EDIT_SOCIAL_VIBER,
    TEMPLATE_CLONE_SOCIAL_VIBER,
    TEMPLATE_CLONE_SOCIAL_WHATS_APP,
    TEMPLATE_CLONE_PUSH_NOTIFICATION,
    TEMPLATE_CREATE_PUSH_NOTIFICATION,
    TEMPLATE_CREATE_PREDEFINED_PUSH_NOTIFICATION,
    TEMPLATE_EDIT_PUSH_NOTIFICATION,
    TEMPLATE_EDIT_PREDEFINED_PUSH_NOTIFICATION,
    TEMPLATE_CLONE_PREDEFINED_PUSH_NOTIFICATION,
    TEMPLATE_CREATE_POP_UP_NOTIFICATION,
    TEMPLATE_CREATE_DYNAMIC_POP_UP,
    TEMPLATE_CREATE_PREDEFINED_DYNAMIC_POP_UP,
    TEMPLATE_EDIT_DYNAMIC_POP_UP,
    TEMPLATE_CLONE_DYNAMIC_POP_UP,
    TEMPLATE_EDIT_POP_UP_NOTIFICATION,
    TEMPLATE_CLONE_POP_UP_NOTIFICATION,
    TEMPLATE_CREATE_CMS_POP_UP_NOTIFICATION,
    TEMPLATE_EDIT_CMS_POP_UP_NOTIFICATION,
    TEMPLATE_CLONE_CMS_POP_UP_NOTIFICATION,
    TEMPLATE_CREATE_CMS_BANNER,
    TEMPLATE_EDIT_CMS_BANNER,
    TEMPLATE_CLONE_CMS_BANNER,
    REPORT_LIST,
    REPORT_CREATE,
    REPORT_PREDEFINED_CREATE,
    REPORT_PREDEFINED_EDIT,
    REPORT_PREDEFINED_CLONE,
    REPORT_CLONE,
    REPORT_EDIT,
    REPORT_EXECUTED_LIST,
    REPORT_SCHEDULE,
    REPORT_EXECUTE,
    CONVERT_TO_REPORT,
    CAMPAIGN_CREATE,
    CAMPAIGN_CREATE_OLD,
    CAMPAIGN_EDIT,
    CAMPAIGN_EDIT_OLD,
    CAMPAIGN_EDIT_APPROVAL_REQUEST,
    CAMPAIGN_CLONE,
    CAMPAIGN_CLONE_OLD,
    CAMPAIGN_REPORT,
    REALTIME_PROMOTIONS_LIST,
    REALTIME_JOURNEY_CREATE,
    REALTIME_JOURNEY_PREDEFINED_CREATE,
    REALTIME_JOURNEY_EDIT,
    REALTIME_JOURNEY_PREDEFINED_EDIT,
    REALTIME_JOURNEY_CLONE,
    REALTIME_JOURNEY_PREDEFINED_CLONE,
    REALTIME_JOURNEY_VIEW,
    COMMUNICATION,
    REALTIME_JOURNEY_REPORT,
    REALTIME_JOURNEY_VISUALIZATION_CREATE,
    REALTIME_JOURNEY_VISUALIZATION_EDIT,
    CONFIGURATION,
    CONFIGURATION_NOTIFICATIONS,
    CONFIGURATION_PROVIDERS,
    CONFIGURATION_AWARDS,
    CONFIGURATION_GENERAL,
    NOTIFICATION,
    REPORT_COMPOSITE_CREATE,
    REPORT_COMPOSITE_CLONE,
    REPORT_COMPOSITE_EDIT,
    ADMINISTRATION,
    ADMINISTRATION_PARTNER_LIST,
    ADMINISTRATION_CJ_BLOCK_MANAGEMENT,
    ADMINISTRATION_PROVIDERS,
    ADMINISTRATION_EMAIL_PROVIDERS,
    ADMINISTRATION_SMS_PROVIDERS,
    ADMINISTRATION_CREATE_SMS_PROVIDER,
    ADMINISTRATION_EDIT_SMS_PROVIDER,
    ADMINISTRATION_CLONE_SMS_PROVIDER,
    ADMINISTRATION_SETTINGS,
    REPORT_CUSTOMER_JOURNEY_CREATE,
    REPORT_CUSTOMER_JOURNEY_EDIT,
    REPORT_CUSTOMER_JOURNEY_CLONE,
    CONFIGURATION_TEMPLATE_LANGUAGES,
    CONFIGURATION_LINK_MANAGEMENT,
    CONFIGURATION_EXCLUSION_RULES,
    CONFIGURATION_EXCLUSION_RULES_CREATE,
    CONFIGURATION_EXCLUSION_RULES_EDIT,
    OBJECT_APPROVAL_REQUEST_LIST,
    OBJECT_APPROVAL_REQUEST_VIEW,
    CONFIGURATION_FORMULA_FILTER,
    CONFIGURATION_FORMULA_FILTER_CREATE,
    CONFIGURATION_FORMULA_FILTER_EDIT,
    CONFIGURATION_FORMULA_FILTER_CLONE,
    CONFIGURATION_ACHIEVEMENT_CREATE,
    CONFIGURATION_ACHIEVEMENT_CLONE,
    CONFIGURATION_ACHIEVEMENT_EDIT,
    CONFIGURATION_ACHIEVEMENT_LIST,
    ADMINISTRATION_DATA_WAREHOUSE,
    ADMINISTRATION_CLASSIFIERS,
    ADMINISTRATION_MENUITEMS,
    ADMINISTRATION_USERS_LIST,
    ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLES_LIST,
    ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLE_CREATE,
    ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLE_EDIT,
    ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLE_CLONE,
    CLIENT_VIEW,
    CLIENT_LIST,
    REALTIME_ACTION_CREATE,
    REALTIME_ACTION_PREDEFINED_CREATE,
    REALTIME_ACTION_EDIT,
    REALTIME_ACTION_PREDEFINED_EDIT,
    REALTIME_ACTION_PREDEFINED_CLONE,
    REALTIME_ACTION_CLONE,
    REALTIME_ACTION_VIEW,
    REALTIME_ACTION_REPORT,
    PROMOTION_TIMELINE,
    AI_SEGMENTATION,
    PREDEFINED_LIST,
    KNOWLEDGE_CENTER,
    KNOWLEDGE_CENTER_SEARCH,
    KNOWLEDGE_CENTER_ARTICLE,
} = RoutesList;

export const mainAppRoutes = [
    {
        titleKey: l.PromotionTimeline,
        path: PROMOTION_TIMELINE.path,
        component: lazy(() => import('pages/PromotionTimelinePage')),
    },
    {
        titleKey: l.HomePage,
        path: HOMEPAGE.path,
        component: lazy(() => import('pages/HomePage')),
    },
    {
        titleKey: l.Dashboard,
        path: DASHBOARD.path,
        component: lazy(() => import('pages/DashboardPage')),
    },
    {
        titleKey: l.SegmentList,
        path: SEGMENT_LIST.path,
        component: lazy(() => import('pages/SegmentListPage')),
    },
    {
        titleKey: l.TemplateList,
        path: TEMPLATE_LIST.path,
        component: lazy(() => import('pages/TemplateListPage')),
    },
    {
        titleKey: l.CampaignList,
        path: CAMPAIGN_LIST.path,
        component: lazy(() => import('pages/CampaignListPage')),
    },
    {
        titleKey: l.CreateDynamicSegment,
        path: SEGMENT_DYNAMIC_CREATE.path,
        component: lazy(() => import('pages/DynamicSegmentCECPPage/DynamicSegmentCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CreatePredefinedDynamicSegment,
        path: SEGMENT_PREDEFINED_CREATE.path,
        component: lazy(() => import('pages/DynamicSegmentCECPPage/DynamicSegmentPredefinedCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.EditDynamicSegment,
        path: SEGMENT_DYNAMIC_EDIT.path,
        component: lazy(() => import('pages/DynamicSegmentCECPPage/DynamicSegmentEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.EditPredefinedDynamicSegment,
        path: SEGMENT_PREDEFINED_EDIT.path,
        component: lazy(() => import('pages/DynamicSegmentCECPPage/DynamicSegmentPredefinedEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },

    {
        titleKey: l.CloneDynamicSegment,
        path: SEGMENT_DYNAMIC_CLONE.path,
        component: lazy(() => import('pages/DynamicSegmentCECPPage/DynamicSegmentClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.ClonePredefinedSegment,
        path: SEGMENT_PREDEFINED_CLONE.path,
        component: lazy(() => import('pages/DynamicSegmentCECPPage/DynamicSegmentClonePredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },

    {
        titleKey: l.CreateStaticSegment,
        path: SEGMENT_STATIC_CREATE.path,
        component: lazy(() => import('pages/StaticSegmentPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CreateNonCustomerSegment,
        path: SEGMENT_NON_CUSTOMER_CREATE.path,
        component: lazy(() => import('pages/NonCustomerSegmentPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CreateCompositeSegment,
        path: SEGMENT_COMPOSITE_CREATE.path,
        component: lazy(() => import('pages/CompositeSegmentCECPage/CompositeSegmentCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CloneCompositeSegment,
        path: SEGMENT_COMPOSITE_CLONE.path,
        component: lazy(() => import('pages/CompositeSegmentCECPage/CompositeSegmentClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.EditCompositeSegment,
        path: SEGMENT_COMPOSITE_EDIT.path,
        component: lazy(() => import('pages/CompositeSegmentCECPage/CompositeSegmentEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CreateEmailTemplate,
        path: TEMPLATE_CREATE_EMAIL.path,
        component: lazy(() => import('pages/EmailTemplateCECPPage/EmailTemplateCreatePage')),
    },
    {
        titleKey: l.CreatePredefinedEmailTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_EMAIL.path,
        component: lazy(() => import('pages/EmailTemplateCECPPage/EmailTemplateCreatePredefinedPage')),
    },

    {
        titleKey: l.CloneEmailTemplate,
        path: TEMPLATE_CREATE_CLONE.path,
        component: lazy(() => import('pages/EmailTemplateCECPPage/EmailTemplateClonePage')),
    },
    {
        titleKey: l.ClonePredefinedEmailTemplate,
        path: TEMPLATE_CLONE_PREDEFINED_EMAIL.path,
        component: lazy(() => import('pages/EmailTemplateCECPPage/EmailTemplateClonePredefinedPage')),
    },
    {
        titleKey: l.EditEmailTemplate,
        path: TEMPLATE_CREATE_EDIT.path,
        component: lazy(() => import('pages/EmailTemplateCECPPage/EmailTemplateEditPage')),
    },
    {
        titleKey: l.EditPredefinedEmailTemplate,
        path: TEMPLATE_EDIT_PREDEFINED_EMAIL.path,
        component: lazy(() => import('pages/EmailTemplateCECPPage/EmailTemplateEditPredefinedPage')),
    },

    {
        titleKey: l.CreatePushNotificationTemplate,
        path: TEMPLATE_CREATE_PUSH_NOTIFICATION.path,
        component: lazy(() => import('pages/PushNotificationTemplateCECPPage/PushNotificationTemplateCreatePage')),
    },
    {
        titleKey: l.CreatePredefinedPushNotificationTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_PUSH_NOTIFICATION.path,
        component: lazy(
            () => import('pages/PushNotificationTemplateCECPPage/PushNotificationTemplateCreatePredefinedPage'),
        ),
    },
    {
        titleKey: l.ClonePushNotificationTemplate,
        path: TEMPLATE_CLONE_PUSH_NOTIFICATION.path,
        component: lazy(() => import('pages/PushNotificationTemplateCECPPage/PushNotificationTemplateClonePage')),
    },
    {
        titleKey: l.ClonePredefinedPushNotificationTemplate,
        path: TEMPLATE_CLONE_PREDEFINED_PUSH_NOTIFICATION.path,
        component: lazy(
            () => import('pages/PushNotificationTemplateCECPPage/PushNotificationTemplateClonePredefinedPage'),
        ),
    },
    {
        titleKey: l.EditPushNotificationTemplate,
        path: TEMPLATE_EDIT_PUSH_NOTIFICATION.path,
        component: lazy(() => import('pages/PushNotificationTemplateCECPPage/PushNotificationTemplateEditPage')),
    },
    {
        titleKey: l.EditPredefinedPushNotificationTemplate,
        path: TEMPLATE_EDIT_PREDEFINED_PUSH_NOTIFICATION.path,
        component: lazy(
            () => import('pages/PushNotificationTemplateCECPPage/PushNotificationTemplateEditPredefinedPage'),
        ),
    },
    {
        titleKey: l.CreatePopUpNotificationTemplate,
        path: TEMPLATE_CREATE_POP_UP_NOTIFICATION.path,
        component: lazy(() => import('pages/PopUpNotificationTemplateCECPage/PopUpNotificationTemplateCreatePage')),
    },
    {
        titleKey: l.EditPopUpNotificationTemplate,
        path: TEMPLATE_EDIT_POP_UP_NOTIFICATION.path,
        component: lazy(() => import('pages/PopUpNotificationTemplateCECPage/PopUpNotificationTemplateEditPage')),
    },
    {
        titleKey: l.ClonePopUpNotificationTemplate,
        path: TEMPLATE_CLONE_POP_UP_NOTIFICATION.path,
        component: lazy(() => import('pages/PopUpNotificationTemplateCECPage/PopUpNotificationTemplateClonePage')),
    },
    {
        titleKey: l.CreateDynamicPopUpTemplate,
        path: TEMPLATE_CREATE_DYNAMIC_POP_UP.path,
        component: lazy(() => import('pages/DynamicPopUpTemplateCECPage/DynamicPopUpTemplateCreatePage')),
    },
    {
        titleKey: l.CreatePredefinedDynamicPopUpTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_DYNAMIC_POP_UP.path,
        component: lazy(() => import('pages/DynamicPopUpTemplateCECPage/DynamicPopUpTemplateCreatePredefinedPage')),
    },
    {
        titleKey: l.EditDynamicPopUpTemplate,
        path: TEMPLATE_EDIT_DYNAMIC_POP_UP.path,
        component: lazy(() => import('pages/DynamicPopUpTemplateCECPage/DynamicPopUpTemplateEditPage')),
    },
    {
        titleKey: l.EditPredefinedDynamicPopUpTemplate,
        path: TEMPLATE_EDIT_PREDEFINED_DYNAMIC_POP_UP.path,
        component: lazy(() => import('pages/DynamicPopUpTemplateCECPage/DynamicPopUpTemplateEditPredefinedPage')),
    },
    {
        titleKey: l.CloneDynamicPopUpTemplate,
        path: TEMPLATE_CLONE_DYNAMIC_POP_UP.path,
        component: lazy(() => import('pages/DynamicPopUpTemplateCECPage/DynamicPopUpTemplateClonePage')),
    },
    {
        titleKey: l.ClonePredefinedDynamicPopUpTemplate,
        path: TEMPLATE_CLONE_PREDEFINED_DYNAMIC_POP_UP.path,
        component: lazy(() => import('pages/DynamicPopUpTemplateCECPage/DynamicPopUpTemplateClonePredefinedPage')),
    },
    {
        titleKey: l.CreateCMSPopUpNotificationTemplate,
        path: TEMPLATE_CREATE_CMS_POP_UP_NOTIFICATION.path,
        component: lazy(
            () => import('pages/CMSPopUpNotificationTemplateCECPage/CMSPopUpNotificationTemplateCreatePage'),
        ),
    },
    {
        titleKey: l.EditCMSPopUpNotificationTemplate,
        path: TEMPLATE_EDIT_CMS_POP_UP_NOTIFICATION.path,
        component: lazy(() => import('pages/CMSPopUpNotificationTemplateCECPage/CMSPopUpNotificationTemplateEditPage')),
    },
    {
        titleKey: l.CloneCMSPopUpNotificationTemplate,
        path: TEMPLATE_CLONE_CMS_POP_UP_NOTIFICATION.path,
        component: lazy(
            () => import('pages/CMSPopUpNotificationTemplateCECPage/CMSPopUpNotificationTemplateClonePage'),
        ),
    },
    {
        titleKey: l.CreateCMSBannerTemplate,
        path: TEMPLATE_CREATE_CMS_BANNER.path,
        component: lazy(() => import('pages/CMSBannerTemplateCECPage/CMSBannerTemplateCreatePage')),
    },
    {
        titleKey: l.EditCMSBannerTemplate,
        path: TEMPLATE_EDIT_CMS_BANNER.path,
        component: lazy(() => import('pages/CMSBannerTemplateCECPage/CMSBannerTemplateEditPage')),
    },
    {
        titleKey: l.CloneCMSBannerTemplate,
        path: TEMPLATE_CLONE_CMS_BANNER.path,
        component: lazy(() => import('pages/CMSBannerTemplateCECPage/CMSBannerTemplateClonePage')),
    },
    {
        titleKey: l.CreateSMSTemplate,
        path: TEMPLATE_CREATE_SMS.path,
        component: lazy(() => import('pages/SMSTemplateCECPPage/SMSTemplateCreatePage')),
    },
    {
        titleKey: l.CreatePredefinedSMSTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_SMS.path,
        component: lazy(() => import('pages/SMSTemplateCECPPage/SMSTemplateCreatePredefinedPage')),
    },
    {
        titleKey: l.CloneSMSTemplate,
        path: TEMPLATE_CLONE_SMS.path,
        component: lazy(() => import('pages/SMSTemplateCECPPage/SMSTemplateClonePage')),
    },
    {
        titleKey: l.ClonePredefinedSMSTemplate,
        path: TEMPLATE_CLONE_PREDEFINED_SMS.path,
        component: lazy(() => import('pages/SMSTemplateCECPPage/SMSTemplateClonePredefinedPage')),
    },
    {
        titleKey: l.EditSMSTemplate,
        path: TEMPLATE_EDIT_SMS.path,
        component: lazy(() => import('pages/SMSTemplateCECPPage/SMSTemplateEditPage')),
    },
    {
        titleKey: l.EditPredefinedSMSTemplate,
        path: TEMPLATE_EDIT_PREDEFINED_SMS.path,
        component: lazy(() => import('pages/SMSTemplateCECPPage/SMSTemplateEditPredefinedPage')),
    },
    {
        titleKey: l.CreateHooryTemplate,
        path: TEMPLATE_CREATE_HOORY.path,
        component: lazy(() => import('pages/HooryTemplateCECPPage/HooryTemplateCreatePage')),
    },
    {
        titleKey: l.CreatePredefinedHooryTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_HOORY.path,
        component: lazy(() => import('pages/HooryTemplateCECPPage/HooryTemplateCreatePredefinedPage')),
    },
    {
        titleKey: l.CloneHooryTemplate,
        path: TEMPLATE_CLONE_HOORY.path,
        component: lazy(() => import('pages/HooryTemplateCECPPage/HooryTemplateClonePage')),
    },
    {
        titleKey: l.ClonePredefinedHooryTemplate,
        path: TEMPLATE_CLONE_PREDEFINED_HOORY.path,
        component: lazy(() => import('pages/HooryTemplateCECPPage/HooryTemplateClonePredefinedPage')),
    },
    {
        titleKey: l.EditHooryTemplate,
        path: TEMPLATE_EDIT_HOORY.path,
        component: lazy(() => import('pages/HooryTemplateCECPPage/HooryTemplateEditPage')),
    },
    {
        titleKey: l.EditPredefinedHooryTemplate,
        path: TEMPLATE_EDIT_PREDEFINED_HOORY.path,
        component: lazy(() => import('pages/HooryTemplateCECPPage/HooryTemplateEditPredefinedPage')),
    },
    {
        titleKey: l.CreateInternalMessageTemplate,
        path: TEMPLATE_CREATE_INTERNAL_MESSAGE.path,
        component: lazy(() => import('pages/InternalMessageTempalteCECPPage/InternalMessageTemplateCreatePage')),
    },
    {
        titleKey: l.CreatePredefinedInternalMessageTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_INTERNAL_MESSAGE.path,
        component: lazy(
            () => import('pages/InternalMessageTempalteCECPPage/InternalMessageTemplateCreatePredefinedPage'),
        ),
    },
    {
        titleKey: l.CloneInternalMessageTemplate,
        path: TEMPLATE_CLONE_INTERNAL_MESSAGE.path,
        component: lazy(() => import('pages/InternalMessageTempalteCECPPage/InternalMessageTemplateClonePage')),
    },
    {
        titleKey: l.ClonePredefinedInternalMessageTemplate,
        path: TEMPLATE_CLONE_PREDEFINED_INTERNAL_MESSAGE.path,
        component: lazy(
            () => import('pages/InternalMessageTempalteCECPPage/InternalMessageTemplateClonePredefinedPage'),
        ),
    },
    {
        titleKey: l.EditInternalMessageTemplate,
        path: TEMPLATE_EDIT_INTERNAL_MESSAGE.path,
        component: lazy(() => import('pages/InternalMessageTempalteCECPPage/InternalMessageTemplateEditPage')),
    },
    {
        titleKey: l.EditPredefinedInternalMessageTemplate,
        path: TEMPLATE_EDIT_PREDEFINED_INTERNAL_MESSAGE.path,
        component: lazy(
            () => import('pages/InternalMessageTempalteCECPPage/InternalMessageTemplateEditPredefinedPage'),
        ),
    },
    {
        titleKey: l.CreateTelegramTemplate,
        path: TEMPLATE_CREATE_SOCIAL_TELEGRAM.path,
        component: lazy(() => import('pages/TelegramTemplateCECPPage/TelegramTemplateCreatePage')),
    },
    {
        titleKey: l.CreatePredefinedTelegramTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_SOCIAL_TELEGRAM.path,
        component: lazy(() => import('pages/TelegramTemplateCECPPage/TelegramTemplateCreatePredefinedPage')),
    },
    {
        titleKey: l.CloneTelegramTemplate,
        path: TEMPLATE_CLONE_SOCIAL_TELEGRAM.path,
        component: lazy(() => import('pages/TelegramTemplateCECPPage/TelegramTemplateClonePage')),
    },
    {
        titleKey: l.ClonePredefinedTelegramTemplate,
        path: TEMPLATE_CLONE_SOCIAL_PREDEFINED_TELEGRAM.path,
        component: lazy(() => import('pages/TelegramTemplateCECPPage/TelegramTemplateClonePredefinedPage')),
    },
    {
        titleKey: l.EditTelegramTemplate,
        path: TEMPLATE_EDIT_SOCIAL_TELEGRAM.path,
        component: lazy(() => import('pages/TelegramTemplateCECPPage/TelegramTemplateEditPage')),
    },
    {
        titleKey: l.EditWhatsAppTemplate,
        path: TEMPLATE_EDIT_SOCIAL_WHATS_APP.path,
        component: lazy(() => import('pages/WhatsAppTemplateCECPage/WhatsAppTemplateEditPage')),
    },
    {
        titleKey: l.EditPredefinedTelegramTemplate,
        path: TEMPLATE_EDIT_SOCIAL_PREDEFINED_TELEGRAM.path,
        component: lazy(() => import('pages/TelegramTemplateCECPPage/TelegramTemplateEditPredefinedPage')),
    },
    {
        titleKey: l.CreateWhatsAppTemplate,
        path: TEMPLATE_CREATE_SOCIAL_WHATS_APP.path,
        component: lazy(() => import('pages/WhatsAppTemplateCECPage/WhatsAppTemplateCreatePage')),
    },
    {
        titleKey: l.CloneWhatsAppTemplate,
        path: TEMPLATE_CLONE_SOCIAL_WHATS_APP.path,
        component: lazy(() => import('pages/WhatsAppTemplateCECPage/WhatsAppTemplateClonePage')),
    },
    {
        titleKey: l.CreateViberTemplate,
        path: TEMPLATE_CREATE_SOCIAL_VIBER.path,
        component: lazy(() => import('pages/ViberTemplateCECPage/ViberTemplateCreatePage')),
    },
    {
        titleKey: l.CreatePredefinedViberTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_SOCIAL_VIBER.path,
        component: lazy(() => import('pages/ViberTemplateCECPage/ViberTemplateCreatePredefinedPage')),
    },
    {
        titleKey: l.CloneViberTemplate,
        path: TEMPLATE_CLONE_SOCIAL_VIBER.path,
        component: lazy(() => import('pages/ViberTemplateCECPage/ViberTemplateClonePage')),
    },
    {
        titleKey: l.ClonePredefinedViberTemplate,
        path: TEMPLATE_CLONE_SOCIAL_PREDEFINED_VIBER.path,
        component: lazy(() => import('pages/ViberTemplateCECPage/ViberTemplateClonePredefinedPage')),
    },
    {
        titleKey: l.EditViberTemplate,
        path: TEMPLATE_EDIT_SOCIAL_VIBER.path,
        component: lazy(() => import('pages/ViberTemplateCECPage/ViberTemplateEditPage')),
    },
    {
        titleKey: l.EditPredefinedViberTemplate,
        path: TEMPLATE_EDIT_SOCIAL_PREDEFINED_VIBER.path,
        component: lazy(() => import('pages/ViberTemplateCECPage/ViberTemplateEditPredefinedPage')),
    },
    {
        titleKey: l.CreateWhatsAppProviderTemplate,
        path: TEMPLATE_CREATE_SOCIAL_WHATS_APP_PROVIDER.path,
        component: lazy(() => import('pages/WhatsAppProviderTemplateCECPage/WhatsAppProviderTemplateCreatePage')),
        isExact: true,
    },
    {
        titleKey: l.CreatePredefinedWhatsAppProviderTemplate,
        path: TEMPLATE_CREATE_PREDEFINED_SOCIAL_WHATS_APP_PROVIDER.path,
        component: lazy(
            () => import('pages/WhatsAppProviderTemplateCECPage/WhatsAppProviderTemplateCreatePredefinedPage'),
        ),
        isExact: true,
    },
    {
        titleKey: l.CloneWhatsAppProviderTemplate,
        path: TEMPLATE_CLONE_SOCIAL_WHATS_APP_PROVIDER.path,
        component: lazy(() => import('pages/WhatsAppProviderTemplateCECPage/WhatsAppProviderTemplateClonePage')),
        isExact: true,
    },
    {
        titleKey: l.ClonePredefinedWhatsAppProviderTemplate,
        path: TEMPLATE_CLONE_PREDEFINED_SOCIAL_WHATS_APP_PROVIDER.path,
        component: lazy(
            () => import('pages/WhatsAppProviderTemplateCECPage/WhatsAppProviderTemplateClonePredefinedPage'),
        ),
        isExact: true,
    },
    {
        titleKey: l.EditWhatsAppProviderTemplate,
        path: TEMPLATE_EDIT_SOCIAL_WHATS_APP_PROVIDER.path,
        component: lazy(() => import('pages/WhatsAppProviderTemplateCECPage/WhatsAppProviderTemplateEditPage')),
        isExact: true,
    },
    {
        titleKey: l.EditPredefinedWhatsAppProviderTemplate,
        path: TEMPLATE_EDIT_PREDEFINED_SOCIAL_WHATS_APP_PROVIDER.path,
        component: lazy(
            () => import('pages/WhatsAppProviderTemplateCECPage/WhatsAppProviderTemplateEditPredefinedPage'),
        ),
        isExact: true,
    },
    {
        titleKey: l.ReportList,
        path: REPORT_LIST.path,
        component: lazy(() => import('pages/ReportListPage')),
    },
    {
        titleKey: l.CreateReport,
        path: REPORT_CREATE.path,
        component: lazy(() => import('pages/ReportCECPage/ReportCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CreatePredefinedReport,
        path: REPORT_PREDEFINED_CREATE.path,
        component: lazy(() => import('pages/ReportCECPage/ReportCreatePredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CloneReport,
        path: REPORT_CLONE.path,
        component: lazy(() => import('pages/ReportCECPage/ReportClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.ClonePredefinedReport,
        path: REPORT_PREDEFINED_CLONE.path,
        component: lazy(() => import('pages/ReportCECPage/ReportClonePredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.EditReport,
        path: REPORT_EDIT.path,
        component: lazy(() => import('pages/ReportCECPage/ReportEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.EditPredefinedReport,
        path: REPORT_PREDEFINED_EDIT.path,
        component: lazy(() => import('pages/ReportCECPage/ReportEditPredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.ExecutedReportsList,
        path: REPORT_EXECUTED_LIST.path,
        component: lazy(() => import('pages/ExecutedReportListPage')),
    },
    {
        titleKey: l.ScheduleReport,
        path: REPORT_SCHEDULE.path,
        component: lazy(() => import('pages/ExecuteReportScheduleCEPage/ReportSchedulePage')),
    },
    {
        titleKey: l.ExecuteReport,
        path: REPORT_EXECUTE.path,
        component: lazy(() => import('pages/ExecuteReportScheduleCEPage/ReportExecutePage')),
    },
    {
        titleKey: l.CreateReportFromSegment,
        path: CONVERT_TO_REPORT.path,
        component: lazy(() => import('pages/ReportCECPage/ConvertToReportPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.CreateCampaign,
        path: CAMPAIGN_CREATE.path,
        component: lazy(() => import('pages/CampaignCECPage/CampaignCreatePageStepper')),
        isExact: true,
    },
    {
        titleKey: l.CreateCampaign,
        path: CAMPAIGN_CREATE_OLD.path,
        component: lazy(() => import('pages/CampaignCECPage/CampaignCreatePage')),
        isExact: true,
    },
    {
        titleKey: l.EditCampaign,
        path: CAMPAIGN_EDIT.path,
        component: lazy(() => import('pages/CampaignCECPage/CampaignEditPageStepper')),
        isExact: true,
    },
    {
        titleKey: l.EditCampaign,
        path: CAMPAIGN_EDIT_APPROVAL_REQUEST.path,
        component: lazy(() => import('pages/CampaignCECPage/CampaignEditPageStepper')),
        isExact: true,
    },
    {
        titleKey: l.EditCampaign,
        path: CAMPAIGN_EDIT_OLD.path,
        component: lazy(() => import('pages/CampaignCECPage/CampaignEditPage')),
        isExact: true,
    },
    {
        titleKey: l.CloneCampaign,
        path: CAMPAIGN_CLONE.path,
        component: lazy(() => import('pages/CampaignCECPage/CampaignClonePageStepper')),
        isExact: true,
    },
    {
        titleKey: l.CloneCampaign,
        path: CAMPAIGN_CLONE_OLD.path,
        component: lazy(() => import('pages/CampaignCECPage/CampaignClonePage')),
        isExact: true,
    },
    {
        titleKey: l.CampaignReport,
        path: CAMPAIGN_REPORT.path,
        component: lazy(() => import('pages/CampaignReportPage')),
    },
    {
        titleKey: l.JourneyPage,
        path: REALTIME_PROMOTIONS_LIST.path,
        component: lazy(() => import('pages/CustomerJourneyListPage')),
    },
    {
        titleKey: l.CreateCustomerJourney,
        path: REALTIME_JOURNEY_CREATE.path,
        component: lazy(() => import('pages/CustomerJourneyCECPVPage/CustomerJourneyCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CreatePredefinedCustomerJourney,
        path: REALTIME_JOURNEY_PREDEFINED_CREATE.path,
        component: lazy(() => import('pages/CustomerJourneyCECPVPage/CustomerJourneyCreatePredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.EditCustomerJourney,
        path: REALTIME_JOURNEY_EDIT.path,
        component: lazy(() => import('pages/CustomerJourneyCECPVPage/CustomerJourneyEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.EditPredefinedCustomerJourney,
        path: REALTIME_JOURNEY_PREDEFINED_EDIT.path,
        component: lazy(() => import('pages/CustomerJourneyCECPVPage/CustomerJourneyEditPredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CloneCustomerJourney,
        path: REALTIME_JOURNEY_CLONE.path,
        component: lazy(() => import('pages/CustomerJourneyCECPVPage/CustomerJourneyClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.ClonePredefinedCustomerJourney,
        path: REALTIME_JOURNEY_PREDEFINED_CLONE.path,
        component: lazy(() => import('pages/CustomerJourneyCECPVPage/CustomerJourneyClonePredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.ViewCustomerJourney,
        path: REALTIME_JOURNEY_VIEW.path,
        component: lazy(() => import('pages/CustomerJourneyCECPVPage/CustomerJourneyViewPage')),
    },
    {
        titleKey: l.Communication,
        path: COMMUNICATION.path,
        component: lazy(() => import('pages/CommunicationPage')),
    },
    {
        titleKey: l.ReportCustomerJourney,
        path: REALTIME_JOURNEY_REPORT.path,
        component: lazy(() => import('pages/CustomerJourneyReportPage')),
    },
    {
        titleKey: l.CreateCustomerJourneyVisualization,
        path: REALTIME_JOURNEY_VISUALIZATION_CREATE.path,
        component: lazy(
            () => import('pages/CustomerJourneyVisualizationCEPage/CustomerJourneyVisualizationCreatePage'),
        ),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.EditCustomerJourneyVisualization,
        path: REALTIME_JOURNEY_VISUALIZATION_EDIT.path,
        component: lazy(() => import('pages/CustomerJourneyVisualizationCEPage/CustomerJourneyVisualizationEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.Configuration,
        path: CONFIGURATION.path,
        component: lazy(() => import('pages/ConfigurationPage')),
        isExact: true,
    },
    {
        titleKey: l.Notifications,
        path: CONFIGURATION_NOTIFICATIONS.path,
        component: lazy(() => import('pages/NotificationsPage')),
    },
    {
        titleKey: l.Providers,
        path: CONFIGURATION_PROVIDERS.path,
        component: lazy(() => import('pages/ProvidersPage')),
    },
    {
        titleKey: l.Awards,
        path: CONFIGURATION_AWARDS.path,
        component: lazy(() => import('pages/AwardsPage')),
    },
    {
        titleKey: l.General,
        path: CONFIGURATION_GENERAL.path,
        component: lazy(() => import('pages/GeneralPage')),
    },
    {
        titleKey: l.NotificationCampaign,
        path: NOTIFICATION.path,
        component: lazy(() => import('pages/NotificationPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CreateCompositeReport,
        path: REPORT_COMPOSITE_CREATE.path,
        component: lazy(() => import('pages/CompositeReportCECPage/CompositeReportCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CloneCompositeReport,
        path: REPORT_COMPOSITE_CLONE.path,
        component: lazy(() => import('pages/CompositeReportCECPage/CompositeReportClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.EditCompositeReport,
        path: REPORT_COMPOSITE_EDIT.path,
        component: lazy(() => import('pages/CompositeReportCECPage/CompositeReportEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.Administration,
        path: ADMINISTRATION.path,
        component: lazy(() => import('pages/AdministrationPage')),
        isExact: true,
    },
    {
        titleKey: l.PartnerList,
        path: ADMINISTRATION_PARTNER_LIST.path,
        component: lazy(() => import('pages/AdministrationPage/PartnersListPage')),
    },
    {
        titleKey: l.CJBlockManagement,
        path: ADMINISTRATION_CJ_BLOCK_MANAGEMENT.path,
        component: lazy(() => import('pages/AdministrationPage/CJBlockManagementPage')),
    },
    {
        titleKey: l.AdministrationProviders,
        path: ADMINISTRATION_PROVIDERS.path,
        component: lazy(() => import('pages/AdministrationPage/ProvidersPage')),
        isExact: true,
    },
    {
        titleKey: l.AdministrationEmailProviders,
        path: ADMINISTRATION_EMAIL_PROVIDERS.path,
        component: lazy(() => import('pages/AdministrationPage/EmailProvidersListPage')),
        isExact: true,
    },
    {
        titleKey: l.AdministrationSMSProviders,
        path: ADMINISTRATION_SMS_PROVIDERS.path,
        component: lazy(() => import('pages/AdministrationPage/SMSProvidersListPage')),
        isExact: true,
    },
    {
        titleKey: l.CreateSMSProvider,
        path: ADMINISTRATION_CREATE_SMS_PROVIDER.path,
        component: lazy(() => import('pages/AdministrationPage/SMSProviderCECPage/SMSProviderCreatePage')),
    },
    {
        titleKey: l.EditSMSProvider,
        path: ADMINISTRATION_EDIT_SMS_PROVIDER.path,
        component: lazy(() => import('pages/AdministrationPage/SMSProviderCECPage/SMSProviderEditPage')),
    },
    {
        titleKey: l.CloneSMSProvider,
        path: ADMINISTRATION_CLONE_SMS_PROVIDER.path,
        component: lazy(() => import('pages/AdministrationPage/SMSProviderCECPage/SMSProviderClonePage')),
    },
    {
        titleKey: l.AdministrationSettings,
        path: ADMINISTRATION_SETTINGS.path,
        component: lazy(() => import('pages/AdministrationPage/SettingsListPage')),
    },
    {
        titleKey: l.DataWarehouse,
        path: ADMINISTRATION_DATA_WAREHOUSE.path,
        component: lazy(() => import('pages/AdministrationPage/DataWarehouseListPage')),
    },
    {
        titleKey: l.AdministrationClassifiers,
        path: ADMINISTRATION_CLASSIFIERS.path,
        component: lazy(() => import('pages/AdministrationPage/ClassifiersListPage')),
    },
    {
        titleKey: l.AdministrationMenuItems,
        path: ADMINISTRATION_MENUITEMS.path,
        component: lazy(() => import('pages/AdministrationPage/MenuItemsListPage')),
    },
    {
        titleKey: l.UserManagement,
        path: ADMINISTRATION_USERS_LIST.path,
        component: lazy(() => import('pages/AdministrationPage/UsersListPage')),
    },
    {
        titleKey: l.KnowledgeCenterArticles,
        path: ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLES_LIST.path,
        component: lazy(() => import('pages/AdministrationPage/KnowledgeCenterArticlesListPage')),
        isExact: true,
    },
    {
        titleKey: l.CreateArticle,
        path: ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLE_CREATE.path,
        component: lazy(
            () => import('pages/AdministrationPage/KnowledgeCenterArticleCECPage/KnowledgeCenterArticleCreatePage'),
        ),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.EditArticle,
        path: ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLE_EDIT.path,
        component: lazy(
            () => import('pages/AdministrationPage/KnowledgeCenterArticleCECPage/KnowledgeCenterArticleEditPage'),
        ),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.CloneArticle,
        path: ADMINISTRATION_KNOWLEDGE_CENTER_ARTICLE_CLONE.path,
        component: lazy(
            () => import('pages/AdministrationPage/KnowledgeCenterArticleCECPage/KnowledgeCenterArticleClonePage'),
        ),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.CreateCustomerJourneyReport,
        path: REPORT_CUSTOMER_JOURNEY_CREATE.path,
        component: lazy(() => import('pages/CustomerJourneyReportCECPage/CustomerJourneyReportCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.EditCustomerJourneyReport,
        path: REPORT_CUSTOMER_JOURNEY_EDIT.path,
        component: lazy(() => import('pages/CustomerJourneyReportCECPage/CustomerJourneyReportEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CloneCustomerJourneyReport,
        path: REPORT_CUSTOMER_JOURNEY_CLONE.path,
        component: lazy(() => import('pages/CustomerJourneyReportCECPage/CustomerJourneyReportClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.TemplateLanguages,
        path: CONFIGURATION_TEMPLATE_LANGUAGES.path,
        component: lazy(() => import('pages/TemplateLanguagesPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.LinkManagement,
        path: CONFIGURATION_LINK_MANAGEMENT.path,
        component: lazy(() => import('pages/ConfigurationPage/LinkManagementPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.ExclusionRulesManagement,
        path: CONFIGURATION_EXCLUSION_RULES.path,
        component: lazy(() => import('pages/ConfigurationPage/ExclusionRulesListPage/ExclusionRulesListPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.ExclusionRulesManagementCreate,
        path: CONFIGURATION_EXCLUSION_RULES_CREATE.path,
        component: lazy(() => import('pages/ConfigurationPage/ExclusionRulesCEPage/ExclusionRulesCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.ExclusionRulesManagementEdit,
        path: CONFIGURATION_EXCLUSION_RULES_EDIT.path,
        component: lazy(() => import('pages/ConfigurationPage/ExclusionRulesCEPage/ExclusionRulesEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.PromotionApprovalList,
        path: OBJECT_APPROVAL_REQUEST_LIST.path,
        component: lazy(() => import('pages/ObjectApprovalListPage')),
        isExact: true,
    },
    {
        titleKey: l.ViewPromotionApproval,
        path: OBJECT_APPROVAL_REQUEST_VIEW.path,
        component: lazy(() => import('pages/ObjectApprovalViewPage')),
        isExact: true,
    },
    {
        titleKey: l.FormulaFilterList,
        path: CONFIGURATION_FORMULA_FILTER.path,
        component: lazy(() => import('pages/ConfigurationPage/FormulaFilterListPage')),
    },
    {
        titleKey: l.CreateFormulaFilter,
        path: CONFIGURATION_FORMULA_FILTER_CREATE.path,
        component: lazy(() => import('pages/ConfigurationPage/FormulaFilterCECPage/FormulaFilterCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.EditFormulaFilter,
        path: CONFIGURATION_FORMULA_FILTER_EDIT.path,
        component: lazy(() => import('pages/ConfigurationPage/FormulaFilterCECPage/FormulaFilterEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.CloneFormulaFilter,
        path: CONFIGURATION_FORMULA_FILTER_CLONE.path,
        component: lazy(() => import('pages/ConfigurationPage/FormulaFilterCECPage/FormulaFilterClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.CreateAchievement,
        path: CONFIGURATION_ACHIEVEMENT_CREATE.path,
        component: lazy(() => import('pages/ConfigurationPage/AchievementCECPage/AchievementCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.CloneAchievement,
        path: CONFIGURATION_ACHIEVEMENT_CLONE.path,
        component: lazy(() => import('pages/ConfigurationPage/AchievementCECPage/AchievementClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.EditAchievement,
        path: CONFIGURATION_ACHIEVEMENT_EDIT.path,
        component: lazy(() => import('pages/ConfigurationPage/AchievementCECPage/AchievementEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
        isExact: true,
    },
    {
        titleKey: l.ViewClient,
        path: CLIENT_VIEW.path,
        component: lazy(() => import('pages/ClientViewPage')),
    },
    {
        titleKey: l.ClientList,
        path: CLIENT_LIST.path,
        component: lazy(() => import('pages/ClientListPage')),
    },
    {
        titleKey: l.CreateActionCampaign,
        path: REALTIME_ACTION_CREATE.path,
        component: lazy(() => import('pages/ActionCampaignCECVPage/ActionCampaignCreatePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CreatePredefinedActionCampaign,
        path: REALTIME_ACTION_PREDEFINED_CREATE.path,
        component: lazy(() => import('pages/ActionCampaignCECVPage/ActionCampaignCreatePredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },

    {
        titleKey: l.EditActionCampaign,
        path: REALTIME_ACTION_EDIT.path,
        component: lazy(() => import('pages/ActionCampaignCECVPage/ActionCampaignEditPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.EditPredefinedActionCampaign,
        path: REALTIME_ACTION_PREDEFINED_EDIT.path,
        component: lazy(() => import('pages/ActionCampaignCECVPage/ActionCampaignEditPredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.ChangeRelated,
    },
    {
        titleKey: l.CloneActionCampaign,
        path: REALTIME_ACTION_CLONE.path,
        component: lazy(() => import('pages/ActionCampaignCECVPage/ActionCampaignClonePage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.ClonePredefinedActionCampaign,
        path: REALTIME_ACTION_PREDEFINED_CLONE.path,
        component: lazy(() => import('pages/ActionCampaignCECVPage/ActionCampaignClonePredefinedPage')),
        routeLeaveConfirmationType: RouteLeaveConfirmationType.Always,
    },
    {
        titleKey: l.ViewActionCampaign,
        path: REALTIME_ACTION_VIEW.path,
        component: lazy(() => import('pages/ActionCampaignCECVPage/ActionCampaignViewPage')),
    },
    {
        titleKey: l.ReportActionCampaign,
        path: REALTIME_ACTION_REPORT.path,
        component: lazy(() => import('pages/ActionCampaignReportPage')),
    },
    {
        titleKey: l.AISegmentation,
        path: AI_SEGMENTATION.path,
        component: lazy(() => import('pages/AISegmentationPage')),
    },
    {
        titleKey: l.PredefinedList,
        path: PREDEFINED_LIST.path,
        component: lazy(() => import('pages/PredefinedListPage')),
    },
    {
        titleKey: l.KnowledgeCenterSearch,
        path: KNOWLEDGE_CENTER_SEARCH.path,
        component: lazy(() => import('pages/KnowledgeCenterSearchPage')),
        isExact: true,
    },
    {
        titleKey: l.KnowledgeCenterArticle,
        path: KNOWLEDGE_CENTER_ARTICLE.path,
        component: lazy(() => import('pages/KnowledgeCenterArticlePage')),
        exact: true,
    },
    {
        titleKey: l.KnowledgeCenter,
        path: KNOWLEDGE_CENTER.path,
        component: lazy(() => import('pages/KnowledgeCenterPage')),
    },
    {
        titleKey: l.AchievementList,
        path: CONFIGURATION_ACHIEVEMENT_LIST.path,
        component: lazy(() => import('pages/ConfigurationPage/AchievementsListPage')),
    },
];

export const publicRoutesList: PublicRoute[] = [
    {
        titleKey: l.SignIn,
        path: `/${SSO_SIGN_IN.path}`,
        component: lazy(() => import('pages/SignInPage/SSOSignInPage')),
        exact: false,
        isPrivate: false,
    },
    {
        titleKey: l.SignIn,
        path: `/${CRM_SIGN_IN.path}`,
        component: lazy(() => import('pages/SignInPage/CRMSignInPage')),
        exact: false,
        isPrivate: false,
    },
    {
        titleKey: l.ResetPassword,
        path: `/${CRM_RESET_PASSWORD.path}`,
        component: lazy(() => import('pages/ResetPasswordPage/ResetPasswordEmailPage')),
        exact: true,
        isPrivate: false,
    },
    {
        titleKey: l.ConfirmResetPassword,
        path: `/${CRM_RESET_PASSWORD_CONFIRM.path}`,
        component: lazy(() => import('pages/ResetPasswordPage/ResetPasswordConfirmationPage')),
        exact: true,
        isPrivate: false,
    },
    {
        titleKey: l.ConfirmResetPassword,
        path: `/${CRM_RESET_PASSWORD_CONFIRM.path}/:token`,
        component: lazy(() => import('pages/ResetPasswordPage/ResetPasswordConfirmationPage')),
        exact: false,
        isPrivate: false,
    },
    {
        titleKey: l.MainApp,
        path: '/crm',
        component: lazy(() => import('components/MainApp')),
        exact: false,
        isPrivate: true,
    },
];

export const notFoundRoute = {
    titleKey: l.NotFound,
    component: lazy(() => import('pages/NotFoundPage')),
};

export const allRoutePaths = publicRoutesList
    .map((item) => item.path)
    .concat(mainAppRoutes.map((item) => `/crm/${item.path}`))
    .map((item) => {
        // eslint-disable-next-line
        const params = [...item.matchAll(/(?<param>:[^\/]+)/g)].map((m) => ({
            value: m?.groups?.param,
            key: m.groups?.param.substring(1),
        }));
        let regex = `^${item}`;
        params.forEach((param) => {
            regex = regex.replaceAll(param.value ?? '', `(?<${param.key}>[^/.]+)`);
        });
        regex = regex.replaceAll('/', '\\/');
        regex = `${regex}([?].*)*$`;
        return {
            value: item,
            params,
            regex,
        };
    });
